import { render, staticRenderFns } from "./info-row.vue?vue&type=template&id=a4125b48&"
import script from "./info-row.vue?vue&type=script&lang=js&"
export * from "./info-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports